export enum CompanyAddressChangeStepsEnum {
  FormDescription = 0,
  NewAddress = 1
}
